import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=2edaf9cc&scoped=true&"
var script = {}
import style0 from "./empty.vue?vue&type=style&index=0&id=2edaf9cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edaf9cc",
  null
  
)

export default component.exports